import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface EdiViewRegenerationRequest {
  instruction?: string;
  persistInstruction: boolean;
}

@Component({
  selector: 'lib-edi-view-regeneration-dialog',
  templateUrl: './edi-view-regeneration-dialog.component.html',
  styleUrls: ['./edi-view-regeneration-dialog.component.scss'],
  standalone: false
})
export class EdiViewRegenerationDialogComponent {
  @Output() confirmed = new EventEmitter<EdiViewRegenerationRequest>();
  @Output() cancelled = new EventEmitter<void>();

  readonly maxInstructionLength = 1000;
  instruction = '';
  persistInstruction = true;

  @Input()
  set initialInstruction(value: string | undefined) {
    this.instruction = value || '';
    this.persistInstruction = true;
  }

  confirm(): void {
    const instruction = this.instruction.trim();
    if (instruction.length > this.maxInstructionLength) return;
    this.confirmed.emit({
      instruction: instruction || undefined,
      persistInstruction: !!instruction && this.persistInstruction
    });
  }
}
